<!-- Author zhang -->
<!-- 雇用保険被保険者資格喪失届・氏名変更届 -->

<template>
  <div>
    <el-form :inline="true" class="style1">
      <el-form-item>
        <el-button class="el-icon-circle-plus-outline" type="text" @click="dialogVisible = true">{{$t("general.add")}}
        </el-button>
      </el-form-item>
    </el-form>
    <!-- Table -->
    <el-table :data="tableData" highlight-current-row border style="width: 100%; margin-top: 0px"
      :empty-text="$t('general.empty_data')">
      <el-table-column :label="$t('empIns9.name')" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.name }}</span>
        </template>
      </el-table-column>

      <el-table-column :label="$t('empIns9.new_name')" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.new_name }}</span>
        </template>
      </el-table-column>

      <el-table-column :label="$t('empIns9.cause')" align="center" width="225">
        <template slot-scope="scope">
          <span>{{ scope.row.cause }}</span>
        </template>
      </el-table-column>

      <el-table-column :label="$t('empIns9.form16')" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.form16 }}</span>
        </template>
      </el-table-column>

      <el-table-column :label="$t('general.date')" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.date}}</span>
        </template>
      </el-table-column>

      <el-table-column :label="$t('general.operation')" align="center" fixed="right" width="350">
        <template slot-scope="scope">
          <el-button size="mini" type="primary" icon="el-icon-edit" @click="handleEdit(scope.$index, scope.row)">
            {{$t("general.edit")}}
          </el-button>
          <el-button size="mini" type="danger" icon="el-icon-delete" @click="handleDelete(scope.$index, scope.row)">
            {{$t("general.delete")}}
          </el-button>
          <el-button size="mini" type="success" icon="el-icon-success" @click="printPDF(scope.$index, scope.row)">
            {{$t("general.print")}}
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <!--add-->
    <el-dialog :title="$t('general.add')" :append-to-body="true" :visible.sync="dialogVisible" width="60%"
      :before-close="handleClose">
      <el-form :data="tableData" :model="ruleForm" :rules="rules" ref="ruleForm" label-width="160px"
        class="demo-ruleForm" size="medium" :label-position="labelPosition" style="margin-left:50px">

        <el-input type="hidden" v-model="ruleForm.id" />

        <el-row>
          <el-col :span="12">
            <div>

              <el-form-item :label="$t('general.date')" prop="date">
                <el-date-picker prefix-icon="el-icon-edit" v-model="ruleForm.date" size="mini" value-format="yyyy-MM-dd"
                  style="margin-left:10px;width: 185px" type="date" :placeholder="$t('general.date')"></el-date-picker>
              </el-form-item>
              <el-form-item :label="$t('general.employee_id')" prop="employee_id">
                <el-select v-model="ruleForm.employee_id" style="margin-left:10px;width: 185px" size="mini"
                  :placeholder="$t('general.select')" @change="employeeIdSelected">
                  <el-option :label="item.employee_id" :value="item.employee_id" v-for="item in empList" :key="item.id">
                  </el-option>
                </el-select>
              </el-form-item>

              <el-form-item :label="$t('empIns9.name')" prop="name">
                <el-input prefix-icon="el-icon-info" v-model="ruleForm.name" size="mini"
                  style="margin-left:10px;width: 185px" :placeholder="$t('empIns9.name')" readonly="readonly">
                </el-input>
              </el-form-item>

              <el-form-item :label="$t('empIns9.resident')" prop="resident" v-if="ruleForm.nation !== 'JPN-日本'">
                <el-input prefix-icon="el-icon-info" v-model="ruleForm.resident" size="mini"
                  style="margin-left:10px;width: 185px" :placeholder="$t('empIns9.resident')" readonly></el-input>
              </el-form-item>

              <el-form-item :label="$t('empIns9.new_name')" prop="new_name">
                <el-input prefix-icon="el-icon-edit" v-model="ruleForm.new_name" size="mini"
                  style="margin-left:10px;width: 185px" :placeholder="$t('empIns9.new_name')">
                </el-input>
              </el-form-item>

              <el-form-item :label="$t('empIns9.form9')" prop="form9">
                <el-select v-model="ruleForm.form9" clearable style="margin-left:10px;width: 185px" size="mini"
                  :placeholder="$t('general.select')">
                  <el-option v-for="item in yesno" :key="item.id" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>

              <el-form-item :label="$t('empIns9.form16')" prop="form16">
                <el-select v-model="ruleForm.form16" clearable style="margin-left:10px;width: 185px" size="mini"
                  :placeholder="$t('general.select')">
                  <el-option v-for="item in form16" :key="item.form16Id" :label="item.name" :value="item.name">
                  </el-option>
                </el-select>
              </el-form-item>

              <el-form-item :label="$t('empIns9.form25')" prop="form25">
                <el-input type="textarea" prefix-icon="el-icon-edit" v-model="ruleForm.form25" size="mini"
                  style="margin-left:10px;width: 185px"></el-input>
              </el-form-item>
            </div>
          </el-col>

          <el-col :span="12">
            <div>
              <el-form-item :label="$t('empIns9.name_change_date')" prop="date">
                <el-date-picker prefix-icon="el-icon-edit" v-model="ruleForm.name_change_date" size="mini"
                  value-format="yyyy-MM-dd" style="margin-left:10px;width: 185px" type="date"
                  :placeholder="$t('general.date')"></el-date-picker>
              </el-form-item>

              <el-form-item :label="$t('empList.mynum')" prop="mynum">
                <el-input prefix-icon="el-icon-info" v-model="ruleForm.mynum" size="mini"
                  style="margin-left:10px;width: 185px" :placeholder="$t('empList.mynum')" readonly="readonly">
                </el-input>
              </el-form-item>

              <el-form-item :label="$t('empIns9.nation')" prop="nation">
                <el-input prefix-icon="el-icon-info" v-model="ruleForm.nation" size="mini"
                  style="margin-left:10px;width: 185px" :placeholder="$t('empIns9.nation')" readonly></el-input>
              </el-form-item>

              <el-form-item :label="$t('empIns9.resident_date')" prop="resident_date"
                v-if="ruleForm.nation !== 'JPN-日本'">
                <el-input prefix-icon="el-icon-info" v-model="ruleForm.resident_date" size="mini"
                  style="margin-left:10px;width: 185px" :placeholder="$t('empIns9.resident_date')" readonly></el-input>
              </el-form-item>

              <el-form-item :label="$t('empIns9.new_namefrgn')" prop="new_name">
                <el-input prefix-icon="el-icon-edit" v-model="ruleForm.new_namefrgn" size="mini"
                  style="margin-left:10px;width: 185px" :placeholder="$t('empIns9.new_namefrgn')">
                </el-input>
              </el-form-item>

              <el-form-item :label="$t('empIns9.wish')" prop="wish">
                <el-select v-model="ruleForm.wish" clearable style="margin-left:10px;width: 185px" size="mini"
                  :placeholder="$t('general.select')">
                  <el-option v-for="item in yesno" :key="item.id" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>

              <el-form-item :label="$t('empIns9.cause')" prop="cause">
                <el-select v-model="ruleForm.cause" clearable style="margin-left:10px;width: 185px" size="mini"
                  :placeholder="$t('general.select')">
                  <el-option v-for="item in causes" :key="item.causesId" :label="item.name" :value="item.name">
                  </el-option>
                </el-select>
              </el-form-item>

              <el-form-item :label="$t('empIns4.week_work_time')" prop="week_work_time">
                <el-input prefix-icon="el-icon-edit" v-model="ruleForm.week_work_hour" size="mini"
                  style="margin-left:10px;width: 70px" :placeholder="$t('empIns4.hour')"></el-input>
                {{$t("empIns4.hour")}}
                <el-input prefix-icon="el-icon-edit" v-model="ruleForm.week_work_min" size="mini"
                  style="margin-left:10px;width: 70px" :placeholder="$t('empIns4.minute')"></el-input>
                {{$t("empIns4.minute")}}
              </el-form-item>

              <el-form-item class="item1" :label="$t('empIns9.new_namefrgn')" prop="new_namefrgn">
                <el-input prefix-icon="el-icon-edit" v-model="ruleForm.new_namefrgn" size="mini" hidden:true
                  style="margin-left:10px;width: 185px"></el-input>
              </el-form-item>
            </div>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button style="width:120px" @click="addUser('ruleForm')" type="primary" size="medium">
          {{$t("general.confirm")}}
        </el-button>
        <el-button style="width:120px" @click="s1_cancel('ruleForm')" size="medium">{{$t("general.cancel")}}</el-button>
      </span>
    </el-dialog>

    <!-- Edit -->
    <el-dialog :title="$t('general.edit')" :append-to-body="true" :visible.sync="dialogUpdate" width="60%"
      :before-close="handleClose">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="160px" class="demo-ruleForm" size="medium"
        :label-position="labelPosition" style="margin-left:50px">

        <el-input type="hidden" v-model="ruleForm.id" />

        <el-row>
          <el-col :span="12">
            <div>
              <el-form-item :label="$t('general.date')" prop="date">
                <el-date-picker prefix-icon="el-icon-edit" v-model="ruleForm.date" size="mini" value-format="yyyy-MM-dd"
                  style="margin-left:10px;width: 185px" type="date" :placeholder="$t('general.date')"></el-date-picker>
              </el-form-item>
              <el-form-item :label="$t('general.employee_id')" prop="employee_id">
                <el-select v-model="ruleForm.employee_id" style="margin-left:10px;width: 185px" size="mini"
                  :placeholder="$t('general.select')" @change="employeeIdSelected">
                  <el-option v-for="item in empList" :key="item.id" :label="item.employee_id" :value="item.employee_id">
                  </el-option>
                </el-select>
              </el-form-item>

              <el-form-item :label="$t('empIns9.name')" prop="name">
                <el-input prefix-icon="el-icon-info" v-model="ruleForm.name" size="mini"
                  style="margin-left:10px;width: 185px" :placeholder="$t('empIns9.name')" readonly="readonly">
                </el-input>
              </el-form-item>

              <el-form-item :label="$t('empIns9.resident')" prop="resident" v-if="ruleForm.nation !== 'JPN-日本'">
                <el-input prefix-icon="el-icon-info" v-model="ruleForm.resident" size="mini"
                  style="margin-left:10px;width: 185px" :placeholder="$t('empIns9.resident')" readonly></el-input>
              </el-form-item>

              <el-form-item :label="$t('empIns9.new_name')" prop="new_name">
                <el-input prefix-icon="el-icon-edit" v-model="ruleForm.new_name" size="mini"
                  style="margin-left:10px;width: 185px" :placeholder="$t('empIns9.new_name')">
                </el-input>
              </el-form-item>

              <el-form-item :label="$t('empIns9.form9')" prop="form9">
                <el-select v-model="ruleForm.form9" clearable style="margin-left:10px;width: 185px" size="mini"
                  :placeholder="$t('general.select')">
                  <el-option v-for="item in yesno" :key="item.id" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>

              <el-form-item :label="$t('empIns9.form16')" prop="form16">
                <el-select v-model="ruleForm.form16" clearable style="margin-left:10px;width: 185px" size="mini"
                  :placeholder="$t('general.select')">
                  <el-option v-for="item in form16" :key="item.form16Id" :label="item.name" :value="item.name">
                  </el-option>
                </el-select>
              </el-form-item>

              <el-form-item :label="$t('empIns9.form25')" prop="form25">
                <el-input type="textarea" prefix-icon="el-icon-edit" v-model="ruleForm.form25" size="mini"
                  style="margin-left:10px;width: 185px"></el-input>
              </el-form-item>
            </div>
          </el-col>

          <el-col :span="12">
            <div>
              <el-form-item :label="$t('empIns9.name_change_date')" prop="date">
                <el-date-picker prefix-icon="el-icon-edit" v-model="ruleForm.name_change_date" size="mini"
                  value-format="yyyy-MM-dd" style="margin-left:10px;width: 185px" type="date"
                  :placeholder="$t('general.date')"></el-date-picker>
              </el-form-item>

              <el-form-item :label="$t('empList.mynum')" prop="mynum">
                <el-input prefix-icon="el-icon-info" v-model="ruleForm.mynum" size="mini"
                  style="margin-left:10px;width: 185px" :placeholder="$t('empList.mynum')" readonly="readonly">
                </el-input>
              </el-form-item>

              <el-form-item :label="$t('empIns9.nation')" prop="nation">
                <el-input prefix-icon="el-icon-info" v-model="ruleForm.nation" size="mini"
                  style="margin-left:10px;width: 185px" :placeholder="$t('empIns9.nation')" readonly></el-input>
              </el-form-item>

              <el-form-item :label="$t('empIns9.resident_date')" prop="resident_date"
                v-if="ruleForm.nation !== 'JPN-日本'">
                <el-input prefix-icon="el-icon-info" v-model="ruleForm.resident_date" size="mini"
                  style="margin-left:10px;width: 185px" :placeholder="$t('empIns9.resident_date')" readonly></el-input>
              </el-form-item>

              <el-form-item :label="$t('empIns9.new_namefrgn')" prop="new_name">
                <el-input prefix-icon="el-icon-edit" v-model="ruleForm.new_namefrgn" size="mini"
                  style="margin-left:10px;width: 185px" :placeholder="$t('empIns9.new_namefrgn')">
                </el-input>
              </el-form-item>

              <el-form-item :label="$t('empIns9.wish')" prop="wish">
                <el-select v-model="ruleForm.wish" clearable style="margin-left:10px;width: 185px" size="mini"
                  :placeholder="$t('general.select')">
                  <el-option v-for="item in yesno" :key="item.id" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>

              <el-form-item :label="$t('empIns9.cause')" prop="cause">
                <el-select v-model="ruleForm.cause" clearable style="margin-left:10px;width: 185px" size="mini"
                  :placeholder="$t('general.select')">
                  <el-option v-for="item in causes" :key="item.causesId" :label="item.name" :value="item.name">
                  </el-option>
                </el-select>
              </el-form-item>

              <el-form-item :label="$t('empIns4.week_work_time')" prop="week_work_time">
                <el-input prefix-icon="el-icon-edit" v-model="ruleForm.week_work_hour" size="mini"
                  style="margin-left:10px;width: 70px" :placeholder="$t('empIns4.hour')"></el-input>
                {{$t("empIns4.hour")}}
                <el-input prefix-icon="el-icon-edit" v-model="ruleForm.week_work_min" size="mini"
                  style="margin-left:10px;width: 70px" :placeholder="$t('empIns4.minute')"></el-input>
                {{$t("empIns4.minute")}}
              </el-form-item>

              <el-form-item class="item1" :label="$t('empIns9.new_namefrgn')" prop="new_namefrgn">
                <el-input prefix-icon="el-icon-edit" v-model="ruleForm.new_namefrgn" size="mini" hidden:true
                  style="margin-left:10px;width: 185px"></el-input>
              </el-form-item>
            </div>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button style="width:120px" @click="updateUser('ruleForm')" type="primary" size="medium">
          {{$t("general.confirm")}}
        </el-button>
        <el-button style="width:120px" @click="s1_cancel('ruleForm')" size="medium">{{$t("general.cancel")}}</el-button>
      </span>
    </el-dialog>

    <br />

    <div class="pages">
      <el-pagination background :disabled="disablePage" :current-page.sync="currentPage" small
        layout="prev, pager, next" :page-size="pageSize" :total="total" @current-change="handleCurrentChange">
      </el-pagination>
    </div>

    <!-- <br>
 test
 <div v-for="existID in tableData" :key="existID.id" :label="existID.employee_id" :value="existID.employee_id" >
 <div v-for="item in empList" :key="item.id" :label="item.employee_id" :value="item.employee_id"> 
      <p >{{item.employee_id}} </p>
    </div> -->
  </div>

</template>

<script>
  export default {
    data() {
      return {
        labelPosition: "left",
        nations: [{
          nationsId: 1,
          name: this.$t("empIns9.aus")
        },
        {
          nationsId: 2,
          name: this.$t("empIns9.bra")
        },
        {
          nationsId: 3,
          name: this.$t("empIns9.mmr")
        },
        {
          nationsId: 4,
          name: this.$t("empIns9.can")
        },
        {
          nationsId: 5,
          name: this.$t("empIns9.chn")
        },
        {
          nationsId: 6,
          name: this.$t("empIns9.fra")
        },
        {
          nationsId: 7,
          name: this.$t("empIns9.deu")
        },
        {
          nationsId: 8,
          name: this.$t("empIns9.hkg")
        },
        {
          nationsId: 9,
          name: this.$t("empIns9.ind")
        },
        {
          nationsId: 10,
          name: this.$t("empIns9.jpn")
        },
        {
          nationsId: 11,
          name: this.$t("empIns9.kor")
        },
        {
          nationsId: 12,
          name: this.$t("empIns9.phl")
        },
        {
          nationsId: 13,
          name: this.$t("empIns9.twn")
        },
        {
          nationsId: 14,
          name: this.$t("empIns9.tha")
        },
        {
          nationsId: 15,
          name: this.$t("empIns9.usa")
        },
        {
          nationsId: 16,
          name: this.$t("empIns9.vnm")
        }
        ],
        residents: [{
          residentsId: 1,
          name: this.$t("empIns9.r1")
        },
        {
          residentsId: 2,
          name: this.$t("empIns9.r2")
        },
        {
          residentsId: 3,
          name: this.$t("empIns9.r3")
        },
        {
          residentsId: 4,
          name: this.$t("empIns9.r4")
        },
        {
          residentsId: 5,
          name: this.$t("empIns9.r5")
        },
        {
          residentsId: 6,
          name: this.$t("empIns9.r6")
        },
        {
          residentsId: 7,
          name: this.$t("empIns9.r7")
        },
        {
          residentsId: 8,
          name: this.$t("empIns9.r8")
        },
        {
          residentsId: 9,
          name: this.$t("empIns9.r9")
        },
        {
          residentsId: 10,
          name: this.$t("empIns9.r10")
        },
        {
          residentsId: 11,
          name: this.$t("empIns9.r11")
        },
        {
          residentsId: 12,
          name: this.$t("empIns9.r12")
        },
        {
          residentsId: 13,
          name: this.$t("empIns9.r13")
        },
        {
          residentsId: 14,
          name: this.$t("empIns9.r14")
        },
        {
          residentsId: 15,
          name: this.$t("empIns9.r15")
        },
        {
          residentsId: 16,
          name: this.$t("empIns9.r16")
        },
        {
          residentsId: 17,
          name: this.$t("empIns9.r17")
        },
        {
          residentsId: 18,
          name: this.$t("empIns9.r18")
        },
        {
          residentsId: 19,
          name: this.$t("empIns9.r19")
        },
        {
          residentsId: 20,
          name: this.$t("empIns9.r20")
        },
        {
          residentsId: 21,
          name: this.$t("empIns9.r21")
        },
        {
          residentsId: 22,
          name: this.$t("empIns9.r22")
        },
        {
          residentsId: 23,
          name: this.$t("empIns9.r23")
        },
        {
          residentsId: 24,
          name: this.$t("empIns9.r24")
        },
        {
          residentsId: 25,
          name: this.$t("empIns9.r25")
        },
        {
          residentsId: 26,
          name: this.$t("empIns9.r26")
        },
        {
          residentsId: 27,
          name: this.$t("empIns9.r27")
        },
        {
          residentsId: 28,
          name: this.$t("empIns9.r28")
        },
        {
          residentsId: 29,
          name: this.$t("empIns9.r29")
        },
        {
          residentsId: 30,
          name: this.$t("empIns9.r30")
        },
        {
          residentsId: 31,
          name: this.$t("empIns9.r31")
        }
        ],
        causes: [{
          causesID: "1.離職以外の理由",
          name: this.$t("empIns9.cause1")
        },
        {
          causesID: "2.3以外の離職",
          name: this.$t("empIns9.cause2")
        },
        {
          causesID: "3.事業主の都合による離職",
          name: this.$t("empIns9.cause3")
        }
        ],
        yesno: [{
          value: "有",
          label: this.$t("empIns9.yes")
        },
        {
          value: "無",
          label: this.$t("empIns9.no")
        }
        ],
        form16: [{
          form16ID: "1.派遣・請負労働者として主に当該事業所以外で就労していた場合",
          name: this.$t("empIns9.form1")
        },
        {
          form16ID: "2.1に該当しない場合",
          name: this.$t("empIns9.form2")
        }
        ],
        ruleForm: {
          id: "",
          cause: "",
          wish: "",
          week_work_hour: "00",
          week_work_min: "00",
          form9: "",
          name_change_date: "",
          new_name: "",
          new_namefrgn: "",
          form11: "",
          form16: "",
          form25: "",
          employee_id: "",
          date: "",
          name: "",
          mynum: "",
          nation: "",
          resident: "",
          resident_date: "",
        },
        rules: {
          employee_id: [{
            required: true,
            message: this.$t("general.inputinfo"),
            trigger: "blur",
          },],
          date: [{
            required: true,
            message: this.$t("empIns5.dateRule"),
            trigger: "blur",
          },],
          type: [{
            required: true,
            message: this.$t("general.inputinfo"),
            trigger: "blur",
          },],
          new_name: [{
            required: true,
            message: this.$t("general.inputinfo"),
            trigger: "blur",
          },],
        },
        empList: [{
          id: "",
          employee_id: "",
          name: "",
          mynum: "",
          nation: "",
          resident: "",
          resident_date: "",

        },],
        empList1: [],
        tableData: [],
        exist: [],
        search: "",
        dialogVisible: false,
        dialogUpdate: false,
        pageSize: 6,
        currentPage: 1,
        total: 0,
        disablePage: false
      };
    },
    methods: {
      isDisabled(inList) {
        if (tableData) {
          for (let e in tableData) {
            if (tableData[e].employee_id === inList) {
              return true;
            }
          }
        }
      },
      // removeExist(all_id){
      //   if(all_id){
      //     for(let i in all_id){
      //       if(all_id[i].employee_id !== tableData[i].employee_id){
      //         this.exist.employee_id = all_id[i].employee_id;
      //       }
      //     }
      //   }
      // },
      removeExist() {
        const empId = "255000";
        const exist_emp = empList.findIndex((v) => v.employee_id === empId);
        const removedEmp = empList.splice(exist_emp, 1);
      },
      preview(index, row) {
        var uid = window.localStorage.getItem('LoginUserId');
        window.open(
          "/pdf/雇用保険被保険者資格喪失届・氏名変更届-" + row.name + row.date + "uid=" + uid + ".pdf"

        );
      },
      printPDF(index, row) {
        let postData = this.qs.stringify({
          id: row.id
        });
        this.axios({
          method: "post",
          url: "/EmpIns9PDF",
          data: postData
        })
          .then(response => {
            this.handleCurrentChange();
            this.$message({
              type: "success",
              message: this.$t("general.print_completed")
            });
            setTimeout(() => {
              this.preview(index, row);
            }, 300);
          })
          .catch(error => {
            this.$message({
              type: "warning",
              message: this.$t("general.print_failed")
            });
          });
      },
      employeeIdSelected() {
        console.log(this.ruleForm.employee_id);
        let postData = this.qs.stringify({
          employee_id: this.ruleForm.employee_id,
        });
        this.axios({
          method: "post",
          url: "/ListEmpList",
          data: postData,
        })
          .then((response) => {
            // console.log(response.data);
            this.empList1 = response.data;
            this.emp = this.empList1[0];
            this.ruleForm.name = this.emp.name;
            this.ruleForm.mynum = this.emp.mynum;
            this.ruleForm.nation = this.emp.nation;
            this.ruleForm.resident = this.emp.resident;
            this.ruleForm.resident_date = this.emp.resident_date;
          })
          .catch((error) => {
            console.log(error);
          });
      },
      handleEdit(index, row) {
        this.dialogUpdate = true;
        this.ruleForm = Object.assign({}, row);
      },
      handleDetails(index, row) {
        this.dialogDetails = true;
        this.ruleForm = Object.assign({}, row);
      },
      handleDelete(index, row) {
        // console.log(index, row);
        this.$confirm(this.$t("general.sure_delete"), this.$t("general.hint"), {
          cancelButtonClass: "btn-custom-cancel",
          confirmButtonClass: "btn-custom-confirm",
          confirmButtonText: "OK",
          cancelButtonText: this.$t("general.cancel"),
          type: "warning"
        })
          .then(() => {
            let postData = this.qs.stringify({
              id: row.id
            });
            this.axios({
              method: "post",
              url: "/deleteEmpIns9",
              data: postData
            })
              .then(response => {
                this.getPages();
                this.currentPage = 1;
                this.axios
                  .post("/pageEmpIns9")
                  .then(response => {
                    this.tableData = response.data;
                  })
                  .catch(error => {
                    console.log(error);
                  });
                this.$message({
                  type: "success",
                  message: this.$t("general.delete_completed")
                });
                // console.log(response);
              })
              .catch(error => {
                console.log(error);
              });
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: this.$t("general.canceled")
            });
          });
      },
      handleClose(done) {
        this.$confirm(this.$t("general.close_comfirm", {
          cancelButtonClass: "btn-custom-cancel",
          confirmButtonClass: "btn-custom-confirm",
          confirmButtonText: this.$t("general.confirm"),
          cancelButtonText: this.$t("general.cancel"),
          type: "warning"
        }))
          .then(_ => {
            this.emptyUserData();
            done();
          })
          .catch(_ => { });
      },
      handleCurrentChange() {
        // console.log(`this.$t("general.current_page"): ${this.currentPage}`);
        let postData = this.qs.stringify({
          page: this.currentPage
        });
        this.axios({
          method: "post",
          url: "/pageEmpIns9",
          data: postData
        })
          .then(response => {
            this.tableData = response.data;
          })
          .catch(error => {
            console.log(error);
          });
      },
      s1_cancel(ruleForm) {
        this.dialogUpdate = false;
        this.dialogVisible = false;
        this.emptyUserData();
        this.$refs[ruleForm].resetFields();
      },
      cancel() {
        this.dialogUpdate = false;
        this.dialogVisible = false;
        this.emptyUserData();
      },
      emptyUserData() {
        this.ruleForm = {
          id: "",
          cause: "",
          wish: "",
          week_work_hour: "00",
          week_work_min: "00",
          form9: "",
          name_change_date: "",
          new_name: "",
          new_namefrgn: "",
          form11: "",
          form16: "",
          form25: "",
          employee_id: "",
          date: "",
          name: "",
          mynum: "",
          nation: "",
          resident: "",
          resident_date: "",
        };
      },

      addUser(ruleForm) {
        this.$refs[ruleForm].validate((valid) => {
          if (valid) {
            let postData = this.qs.stringify({
              cause: this.ruleForm.cause,
              wish: this.ruleForm.wish,
              week_work_hour: this.ruleForm.week_work_hour,
              week_work_min: this.ruleForm.week_work_min,
              form9: this.ruleForm.form9,
              name_change_date: this.ruleForm.name_change_date,
              new_name: this.ruleForm.new_name,
              new_namefrgn: this.ruleForm.new_namefrgn,
              form11: this.ruleForm.form11,
              form16: this.ruleForm.form16,
              form25: this.ruleForm.form25,
              employee_id: this.ruleForm.employee_id,
              date: this.ruleForm.date
            });
            this.axios({
              method: "post",
              url: "/insertEmpIns9",
              data: postData
            })
              .then(response => {
                this.axios
                  .post("/pageEmpIns9")
                  .then(response => {
                    this.tableData = response.data;
                    this.currentPage = 1;
                    this.cancel();
                    this.$message({
                      type: "success",
                      message: this.$t("general.add_completed")
                    });
                  })
                  .catch(error => {
                    this.$message({
                      type: "warning",
                      message: this.$t("general.add_failed")
                    });
                    console.log(error);
                  });
                this.getPages();
                this.dialogVisible = false;
                // console.log(response);
              })
              .catch(error => {
                console.log(error);
              });
          } else {
            console.log("error submit!!");
            this.$message({
              type: "error",
              message: this.$t("general.valid_failed")
            });
            return false;
          }
        });
      },
      updateUser(ruleForm) {
        this.$refs[ruleForm].validate((valid) => {
          if (valid) {
            let postData = this.qs.stringify({
              id: this.ruleForm.id,
              cause: this.ruleForm.cause,
              wish: this.ruleForm.wish,
              week_work_hour: this.ruleForm.week_work_hour,
              week_work_min: this.ruleForm.week_work_min,
              form9: this.ruleForm.form9,
              name_change_date: this.ruleForm.name_change_date,
              new_name: this.ruleForm.new_name,
              new_namefrgn: this.ruleForm.new_namefrgn,
              form11: this.ruleForm.form11,
              form16: this.ruleForm.form16,
              form25: this.ruleForm.form25,
              date: this.ruleForm.date,
              employee_id: this.ruleForm.employee_id
            });
            this.axios({
              method: "post",
              url: "/updateEmpIns9",
              data: postData
            })
              .then(response => {
                this.handleCurrentChange();
                this.s1_cancel(ruleForm);
                this.$message({
                  type: "success",
                  message: this.$t("general.edit_completed")
                });
                // console.log(response);
              })
              .catch(error => {
                this.$message({
                  type: "warning",
                  message: this.$t("general.edit_failed")
                });
                console.log(error);
              });
          } else {
            console.log("error submit!!");
            this.$message({
              type: "error",
              message: this.$t("general.valid_failed")
            });
            return false;
          }
        });
      },
      getPages() {
        this.axios
          .post("/rowsEmpIns9")
          .then(response => {
            this.total = response.data;
          })
          .catch(error => {
            console.log(error);
          });
      },
      refreshData() {
        location.reload();
      }
    },
    created() {
      this.axios
        .post("/pageEmpIns9")
        .then(response => {
          this.show = true;
          this.tableData = response.data;
        })
        .catch(error => {
          // this.show = false;
          // this.$message({
          //   type: 'error',
          //   message: '開発中です。'
          // });
          // console.log(error);
        });

      this.axios
        .post("/rowsEmpIns9")
        .then(response => {
          this.total = response.data;
        })
        .catch(error => {
          console.log(error);
        });

      this.axios
        .post("/ListEmpListForInsNameChange")
        .then(response => {
          // console.log(response.data);
          this.empList = response.data;
          removeExist();
          //   console.log(this.empList);
        })
        .catch(error => {
          console.log(error);
        });
    }
  };
</script>


<style>
  .btn-custom-cancel {
    float: right;
    margin-left: 10px;
    width: 90px;
  }

  .btn-custom-confirm {
    width: 90px;
  }
</style>
<style scoped>
  .search_name {
    width: 200px;
  }

  .item1 {
    visibility: hidden;
  }

  .style1 {
    margin-right: 145px;
    padding: 0px;
    text-align: right;
  }

  .pages {
    margin: 0px;
    padding: 0px;
    text-align: right;
  }
</style>


// WEBPACK FOOTER //
// src/components/EmpIns/EmpIns9.vue